import { Fragment, useEffect, useState } from "react";

import { useHistory, withRouter } from "react-router-dom";

import axios from "axios";
import { getUserInfo } from "../../../../modules";

import { useRecoilValue } from "recoil";
import themeAppStore from "../../../../store/theme-app.store";

import moment from "moment";

import toast from "react-hot-toast";

import NumberFormat from "react-number-format";

import Header from "../../../components/Header";

import TrxLoadingDetails from "../../../components/loading/TrxDetails";

const idLocale = require('moment/locale/id')
moment.updateLocale('id', idLocale);

const TrxListDetailsPage: React.FC = (props: any): JSX.Element => {
  if (!props.location.state) window.location.replace("/dashboard");

  const { refId, sellingPrice, admin } = props.location.state;

  interface TrxDetailsSchemaType {
    _id: string;
    admin: string;
    counter: number;
    created_at: string;
    harga_jual: number;
    fee_ppob: number;
    payment_by: string;
    poin: number;
    print: Array<{
      label: string;
      value: string;
    }>;
    produk_id?: { nama: string; description: string, kode_produk: string };
    status: number;
    tujuan: string;
    sn: string;
    updated_at: string;
    header_text?: string;
    footer_text?: string;
  }

  const trxDetailsSchema: TrxDetailsSchemaType = {
    _id: "",
    admin: "",
    counter: 0,
    created_at: "",
    harga_jual: 0,
    fee_ppob: 0,
    payment_by: "",
    poin: 0,
    print: [],
    produk_id: { nama: "", description: "", kode_produk: "" },
    status: 0,
    tujuan: "",
    sn: "",
    updated_at: "",
  }

  const [trxDetailsState, setTrxDetailsState] = useState<TrxDetailsSchemaType>(trxDetailsSchema);

  function getTrxDetails(refId: string, setLoading: React.Dispatch<React.SetStateAction<boolean>>): Promise<unknown> {
    return new Promise((resolve, reject): void => {
      setLoading(true);
      axios({
        url: `${process.env.REACT_APP_API_ENDPOINT_URL}/trx/${refId}/print`,
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("user_token"),
        },
        validateStatus: (status): boolean => true,
      }).then((result: any): void => {
        // console.log('[TRX DETAILS]', result)

        if (result.status === 200) {
          setLoading(false);
          resolve(result);
        } else {
          reject(result);
        }

      }).catch((error: any): void => console.log("STATUS CODE", error));
    });
  };

  interface UserInfoSchemaType {
    aktif: boolean;
    alamat: string;
    created_at: string;
    enable_bank_transfer: boolean;
    id_kabupaten: string;
    id_kecamatan: string;
    id_propinsi: string;
    kode_merchant: string;
    komisi: number;
    kyc: boolean;
    kyc_verification: boolean;
    nama: string;
    phone: string;
    poin: number;
    saldo: number;
    toko: {
      alamat: string;
      nama: string;
    };
    updated_at: string;
    _id: string;
  }

  const userInfoSchema = {
    aktif: false,
    alamat: "",
    created_at: "",
    enable_bank_transfer: false,
    id_kabupaten: "",
    id_kecamatan: "",
    id_propinsi: "",
    kode_merchant: "",
    komisi: 0,
    kyc: false,
    kyc_verification: false,
    nama: "",
    phone: "",
    poin: 0,
    saldo: 0,
    toko: { alamat: "", nama: "" },
    updated_at: "",
    _id: "",
  }

  const [userInfoState, setUserInfoState] = useState<UserInfoSchemaType>(userInfoSchema);

  const [isLoadingState, setIsLoadingState] = useState<boolean>(false);

  useEffect((): void => {
    getTrxDetails(refId, setIsLoadingState).then((result: any) => {
      const statusCode: number = result.data.status;
      const data: any = result.data.data;
      if (statusCode === 200) setTrxDetailsState(data);
    }).catch((e: any): void => {
      toast.error(e.data.message, {
        style: { fontWeight: "bolder" },
      });
      console.log(e);
    });

    getUserInfo(setIsLoadingState).then((result: any) => {
      const statusCode: number = result.data.status;
      const data: any = result.data.data;
      if (statusCode === 200) setUserInfoState(data);
    }).catch((e: any): void => {
      toast.error(e.data.message, {
        style: { fontWeight: "bolder" },
      });
      console.log(e);
    });
  }, [refId]);

  const {
    toko: { nama: merchantName, alamat: merchantAddress },
  } = userInfoState;

  const {
    _id: id,
    counter,
    created_at: createdAt,
    fee_ppob: feePpob,
    payment_by: paymentBy,
    poin: point,
    print,
    produk_id: productId,
    status,
    tujuan: destination,
    sn,
  } = trxDetailsState;

  // SELLING PRICE && ADMIN PRINT EDIT
  const [btnSellingPricePrintState, setBtnSellingPricePrintState] = useState<boolean>(false);
  const [btnSellingAdminPrintState, setBtnSellingAdminPrintState] = useState<boolean>(false);

  const [sellingPricePrintState, setSellingPricePrintState] = useState<number>(0);
  const [sellingAdminPrintState, setSellingAdminPrintState] = useState<number>(0);

  useEffect((): void => {
    // setSellingPricePrintState(sellingPrice);
    
    setSellingPricePrintState(trxDetailsState.harga_jual);
    setSellingAdminPrintState(admin);
  }, [sellingPrice, admin, trxDetailsState]);

  function handleChangeSellingPrice(e: any): void {
    setSellingPricePrintState(parseInt(e.target.value));
  }

  function handleChangeSellingAdmin(e: any): void {
    setSellingAdminPrintState(parseInt(e.target.value));
  }

  interface trxPrintDataType {
    id: string;
    feePpob: number;
    merchantName: string;
    merchantAddress: string;
    productCode: string;
    productName: string;
    destination: string;
    sellingPrice: number;
    sellingAdmin: number;
    print: Array<any>
    sn: string;
    createdAt: string;
    header_text?: string;
    footer_text?: string;
  }

  let trxPrintData: trxPrintDataType = {
    id,
    feePpob,
    merchantName,
    merchantAddress,
    productCode: productId ? productId.kode_produk : '-',
    productName: productId ? productId.nama : '-',
    destination,
    sellingPrice: sellingPricePrintState,
    sellingAdmin: sellingAdminPrintState,
    print: print ? print : [],
    sn,
    createdAt,
    header_text: trxDetailsState.header_text || undefined,
    footer_text: trxDetailsState.footer_text || undefined,
  }

  const history = useHistory();
  function handlePrintStruct(printSize: string, trxPrintData: trxPrintDataType) {
    history.push({
      pathname: '/dashboard/profile/history/trx/print',
      state: { printSize, trxPrintData }
    });
  }

  const ScrollToTopOnMount = (): null => {
    useEffect((): void => {
      window.scrollTo(0, 0);
    }, []);

    return null;
  };

  const themeState = useRecoilValue<string | null>(themeAppStore);

  const contentListTheme: string = themeState === "dark" ? "bg-[#1F283E]" : 'bg-white';

  const labelTheme: string = themeState === "dark" ? "text-gray-400" : 'text-gray-500';

  const borderTheme: string = themeState === "dark" ? "border-gray-700" : '';

  return (
    <Fragment>
      {isLoadingState ? (
        <Fragment>
          <ScrollToTopOnMount />
          <TrxLoadingDetails />
        </Fragment>
      ) : (
        <Fragment>
          <div className="flex justify-between items-center">
            <Header title="Detail Riwayat Transaksi" />
            {status === 2 && (
              <div className="-mt-8">
                <label htmlFor="modal-print-option" className="hidden md:block p-2 text-white font-medium rounded-md focus:outline-none cursor-pointer" style={{ background: process.env.REACT_APP_PRIMARY_COLOR }}>Cetak Struk</label>
                <input type="checkbox" id="modal-print-option" className="modal-toggle" />
                <div className="modal">
                  <div className="modal-box rounded-t-lg sm:rounded-lg bg-white">
                    <div className="flex justify-end mb-3">
                      <label htmlFor="modal-print-option" className="cursor-pointer rounded">
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                      </label>
                    </div>
                    <div className="flex justify-center mb-2">
                      <span className="font-medium text-xl text-gray-800">Pilih Ukuran Kertas Cetak</span>
                    </div>
                    <button onClick={() => handlePrintStruct('58mm', trxPrintData)} className="w-full mt-4 px-3 py-3 text-xs sm:text-base font-medium text-white rounded-md focus:outline-none" style={{ backgroundColor: process.env.REACT_APP_PRIMARY_COLOR }}>
                      Kertas Cetak Ukuran 58mm
                    </button>
                    <button onClick={() => handlePrintStruct('80mm', trxPrintData)} className="w-full mt-4 px-3 py-3 text-xs sm:text-base font-medium text-white rounded-md focus:outline-none" style={{ backgroundColor: process.env.REACT_APP_PRIMARY_COLOR }}>
                      Kertas Cetak Ukuran 80mm
                    </button>
                    <button onClick={() => handlePrintStruct('A4', trxPrintData)} className="w-full mt-4 mb-3 px-3 py-3 text-xs sm:text-base font-medium text-white rounded-md focus:outline-none" style={{ backgroundColor: process.env.REACT_APP_PRIMARY_COLOR }}>
                      Kertas Cetak Ukuran A4
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-center">
            <label htmlFor="modal-print-option" className="block md:hidden p-2 text-xs text-white font-medium rounded-md focus:outline-none cursor-pointer" style={{ background: process.env.REACT_APP_PRIMARY_COLOR }}>Cetak Struk</label>
          </div>
          <div className={`${contentListTheme} p-3 shadow-lg rounded-lg my-3`}>
            <div className={`${borderTheme} flex justify-between p-2 border-b`}>
              <div>
                <span className="text-xs sm:text-base font-medium">{productId?.nama ? productId?.nama : '-'}</span>
              </div>
            </div>

            {/* DESTINATION NUMBER */}
            <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
              <div>
                <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Nomor Tujuan</span>
              </div>
              <div className="flex items-center gap-1 text-left">
                <span className="text-xs sm:text-base font-medium">{destination}</span>
                <button
                  className="copy focus:outline-none"
                  data-clipboard-text={destination}
                  onClick={(): void => {
                    toast.success(`Text Berhasil Di Salin`, {
                      style: { fontWeight: "bolder" },
                    });
                  }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.4 22.75H7.6C3.21 22.75 1.25 20.79 1.25 16.4V12.6C1.25 8.21 3.21 6.25 7.6 6.25H10.6C11.01 6.25 11.35 6.59 11.35 7C11.35 7.41 11.01 7.75 10.6 7.75H7.6C4.02 7.75 2.75 9.02 2.75 12.6V16.4C2.75 19.98 4.02 21.25 7.6 21.25H11.4C14.98 21.25 16.25 19.98 16.25 16.4V13.4C16.25 12.99 16.59 12.65 17 12.65C17.41 12.65 17.75 12.99 17.75 13.4V16.4C17.75 20.79 15.79 22.75 11.4 22.75Z" fill="currentColor" />
                    <path d="M16.9996 14.15H13.7996C10.9896 14.15 9.84961 13.01 9.84961 10.2V6.99999C9.84961 6.69999 10.0296 6.41999 10.3096 6.30999C10.5896 6.18999 10.9096 6.25999 11.1296 6.46999L17.5296 12.87C17.7396 13.08 17.8096 13.41 17.6896 13.69C17.5796 13.97 17.2996 14.15 16.9996 14.15ZM11.3496 8.80999V10.2C11.3496 12.19 11.8096 12.65 13.7996 12.65H15.1896L11.3496 8.80999Z" fill="currentColor" />
                    <path d="M15.5996 2.75H11.5996C11.1896 2.75 10.8496 2.41 10.8496 2C10.8496 1.59 11.1896 1.25 11.5996 1.25H15.5996C16.0096 1.25 16.3496 1.59 16.3496 2C16.3496 2.41 16.0096 2.75 15.5996 2.75Z" fill="currentColor" />
                    <path d="M7 5.75C6.59 5.75 6.25 5.41 6.25 5C6.25 2.93 7.93 1.25 10 1.25H12.62C13.03 1.25 13.37 1.59 13.37 2C13.37 2.41 13.03 2.75 12.62 2.75H10C8.76 2.75 7.75 3.76 7.75 5C7.75 5.41 7.41 5.75 7 5.75Z" fill="currentColor" />
                    <path d="M19.1904 17.75C18.7804 17.75 18.4404 17.41 18.4404 17C18.4404 16.59 18.7804 16.25 19.1904 16.25C20.3304 16.25 21.2504 15.32 21.2504 14.19V8C21.2504 7.59 21.5904 7.25 22.0004 7.25C22.4104 7.25 22.7504 7.59 22.7504 8V14.19C22.7504 16.15 21.1504 17.75 19.1904 17.75Z" fill="currentColor" />
                    <path d="M22 8.74999H19C16.34 8.74999 15.25 7.65999 15.25 4.99999V1.99999C15.25 1.69999 15.43 1.41999 15.71 1.30999C15.99 1.18999 16.31 1.25999 16.53 1.46999L22.53 7.46999C22.74 7.67999 22.81 8.00999 22.69 8.28999C22.58 8.56999 22.3 8.74999 22 8.74999ZM16.75 3.80999V4.99999C16.75 6.82999 17.17 7.24999 19 7.24999H20.19L16.75 3.80999Z" fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>

            {/* PRODUCT DESCRIPTION */}
            <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
              <div>
                <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Deskripsi Produk</span>
              </div>
              <div className="text-left">
                <span className="text-xs sm:text-base font-medium">{productId?.description ? productId?.description : '-'}</span>
              </div>
            </div>

            {/* PRODUCT SELL PRINCE */}
            <div className="flex px-2 py-1 lg:p-2 text-left">
              <div className="flex flex-col">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Harga</span>
                </div>
                {status === 2 ? (
                  <div className="flex">
                    <NumberFormat
                      value={
                        status === 2
                          ? sellingPricePrintState
                            ? sellingPricePrintState
                            : 0
                          : sellingPrice
                      }
                      className="text-xs sm:text-base font-medium"
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                    <div className="ml-2">
                      <button onClick={(): void => setBtnSellingPricePrintState(true)}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z" fill="currentColor" />
                          <path d="M8.50032 17.6901C7.89032 17.6901 7.33032 17.4701 6.92032 17.0701C6.43032 16.5801 6.22032 15.8701 6.33032 15.1201L6.76032 12.1101C6.84032 11.5301 7.22032 10.7801 7.63032 10.3701L15.5103 2.49006C17.5003 0.500059 19.5203 0.500059 21.5103 2.49006C22.6003 3.58006 23.0903 4.69006 22.9903 5.80006C22.9003 6.70006 22.4203 7.58006 21.5103 8.48006L13.6303 16.3601C13.2203 16.7701 12.4703 17.1501 11.8903 17.2301L8.88032 17.6601C8.75032 17.6901 8.62032 17.6901 8.50032 17.6901ZM16.5703 3.55006L8.69032 11.4301C8.50032 11.6201 8.28032 12.0601 8.24032 12.3201L7.81032 15.3301C7.77032 15.6201 7.83032 15.8601 7.98032 16.0101C8.13032 16.1601 8.37032 16.2201 8.66032 16.1801L11.6703 15.7501C11.9303 15.7101 12.3803 15.4901 12.5603 15.3001L20.4403 7.42006C21.0903 6.77006 21.4303 6.19006 21.4803 5.65006C21.5403 5.00006 21.2003 4.31006 20.4403 3.54006C18.8403 1.94006 17.7403 2.39006 16.5703 3.55006Z" fill="currentColor" />
                          <path d="M19.8496 9.83003C19.7796 9.83003 19.7096 9.82003 19.6496 9.80003C17.0196 9.06003 14.9296 6.97003 14.1896 4.34003C14.0796 3.94003 14.3096 3.53003 14.7096 3.41003C15.1096 3.30003 15.5196 3.53003 15.6296 3.93003C16.2296 6.06003 17.9196 7.75003 20.0496 8.35003C20.4496 8.46003 20.6796 8.88003 20.5696 9.28003C20.4796 9.62003 20.1796 9.83003 19.8496 9.83003Z" fill="currentColor" />
                        </svg>
                      </button>
                    </div>
                  </div>
                ) : (
                  <NumberFormat
                    value={status === 2 ? sellingPricePrintState : sellingPrice}
                    className="text-xs sm:text-base font-medium"
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                  />
                )}

                {btnSellingPricePrintState && (
                  <form
                    className="flex items-center"
                    onSubmit={(): void => setBtnSellingPricePrintState(false)}>
                    <input
                      onChange={handleChangeSellingPrice}
                      type="number"
                      value={sellingPricePrintState}
                      className="px-1 text-sm font-medium border rounded"
                    />
                  </form>
                )}
              </div>
            </div>

            {/* PRODUCT ADMIN PRICE */}
            <div className="flex px-2 py-1 lg:p-2 text-left">
              <div className="flex flex-col">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Admin</span>
                </div>
                {status === 2 ? (
                  <div className="flex">
                    <NumberFormat
                      value={
                        status === 2
                          ? sellingAdminPrintState
                            ? sellingAdminPrintState
                            : 0
                          : admin
                      }
                      className="text-xs sm:text-base font-medium"
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                    <div className="ml-2">
                      <button onClick={(): void => setBtnSellingAdminPrintState(true)}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z" fill="currentColor" />
                          <path d="M8.50032 17.6901C7.89032 17.6901 7.33032 17.4701 6.92032 17.0701C6.43032 16.5801 6.22032 15.8701 6.33032 15.1201L6.76032 12.1101C6.84032 11.5301 7.22032 10.7801 7.63032 10.3701L15.5103 2.49006C17.5003 0.500059 19.5203 0.500059 21.5103 2.49006C22.6003 3.58006 23.0903 4.69006 22.9903 5.80006C22.9003 6.70006 22.4203 7.58006 21.5103 8.48006L13.6303 16.3601C13.2203 16.7701 12.4703 17.1501 11.8903 17.2301L8.88032 17.6601C8.75032 17.6901 8.62032 17.6901 8.50032 17.6901ZM16.5703 3.55006L8.69032 11.4301C8.50032 11.6201 8.28032 12.0601 8.24032 12.3201L7.81032 15.3301C7.77032 15.6201 7.83032 15.8601 7.98032 16.0101C8.13032 16.1601 8.37032 16.2201 8.66032 16.1801L11.6703 15.7501C11.9303 15.7101 12.3803 15.4901 12.5603 15.3001L20.4403 7.42006C21.0903 6.77006 21.4303 6.19006 21.4803 5.65006C21.5403 5.00006 21.2003 4.31006 20.4403 3.54006C18.8403 1.94006 17.7403 2.39006 16.5703 3.55006Z" fill="currentColor" />
                          <path d="M19.8496 9.83003C19.7796 9.83003 19.7096 9.82003 19.6496 9.80003C17.0196 9.06003 14.9296 6.97003 14.1896 4.34003C14.0796 3.94003 14.3096 3.53003 14.7096 3.41003C15.1096 3.30003 15.5196 3.53003 15.6296 3.93003C16.2296 6.06003 17.9196 7.75003 20.0496 8.35003C20.4496 8.46003 20.6796 8.88003 20.5696 9.28003C20.4796 9.62003 20.1796 9.83003 19.8496 9.83003Z" fill="currentColor" />
                        </svg>
                      </button>
                    </div>
                  </div>
                ) : (
                  <NumberFormat
                    value={admin}
                    className="text-xs sm:text-base font-medium"
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                  />
                )}

                {btnSellingAdminPrintState && (
                  <form
                    className="flex items-center"
                    onSubmit={(): void => setBtnSellingAdminPrintState(false)}>
                    <input
                      onChange={handleChangeSellingAdmin}
                      type="number"
                      value={sellingAdminPrintState}
                      className="px-1 font-medium text-xs lg:text-sm 2xl:text-base border rounded"
                    />
                  </form>
                )}
              </div>
            </div>

            {/* PAYMENT METHOD */}
            <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
              <div>
                <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Metode Pembayaran</span>
              </div>
              <div>
                <span className="text-xs lg:text-sm font-medium uppercase">{paymentBy}</span>
              </div>
            </div>
          </div>

          {/* TRX INFO */}
          <div className={`${contentListTheme} p-3 shadow-lg rounded-lg`}>
            <div>
              {/* PRICE DETAILS */}
              <div className={`${borderTheme} flex justify-between px-2 py-1 lg:p-2 text-left border-b`}>
                <div>
                  <span className="text-xs sm:text-base font-medium">Informasi Transaksi</span>
                </div>
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5002 22.75C10.7102 22.75 9.96025 22.34 9.44025 21.64L8.42023 20.3C8.21023 20.02 7.93025 19.86 7.63025 19.84C7.34025 19.82 7.03027 19.96 6.78027 20.21C5.92027 21.13 5.08022 21.57 4.29022 21.55C3.75022 21.53 3.28023 21.29 2.92023 20.85C2.88023 20.8 2.84024 20.73 2.81024 20.66C2.42024 19.82 2.24023 18.68 2.24023 16.97V7.05001C2.24023 5.34001 2.42024 4.21001 2.81024 3.36001C2.84024 3.30001 2.87023 3.24001 2.92023 3.19001C3.27023 2.74001 3.74027 2.50001 4.28027 2.47001C5.08027 2.44001 5.93026 2.90001 6.77026 3.80001C7.02026 4.07001 7.32024 4.20001 7.62024 4.18001C7.92024 4.16001 8.20022 4.00001 8.41022 3.72001L9.43024 2.37001C9.95024 1.67001 10.7002 1.26001 11.4902 1.26001C12.2802 1.26001 13.0302 1.67001 13.5502 2.37001L14.5602 3.71001C14.7702 4.00001 15.0602 4.16001 15.3702 4.18001C15.6602 4.20001 15.9702 4.06001 16.2202 3.80001C17.0402 2.92001 17.8502 2.47001 18.6302 2.47001C19.1902 2.47001 19.7103 2.72001 20.0703 3.19001C20.1103 3.24001 20.1502 3.30001 20.1802 3.37001C20.5702 4.21001 20.7502 5.35001 20.7502 7.06001V16.98C20.7502 18.69 20.5702 19.82 20.1802 20.67C20.1402 20.76 20.0903 20.84 20.0203 20.91C19.7103 21.31 19.2002 21.56 18.6302 21.56C17.8502 21.56 17.0402 21.11 16.2202 20.23C15.9802 19.97 15.6502 19.83 15.3702 19.85C15.0602 19.87 14.7802 20.03 14.5602 20.32L13.5502 21.66C13.0402 22.34 12.2902 22.75 11.5002 22.75ZM7.58026 18.33C7.62026 18.33 7.67027 18.33 7.71027 18.33C8.45027 18.37 9.14023 18.76 9.61023 19.39L10.6302 20.74C11.1202 21.4 11.8602 21.4 12.3502 20.75L13.3602 19.41C13.8402 18.77 14.5403 18.39 15.2803 18.35C16.0203 18.31 16.7602 18.62 17.3002 19.2C18.0402 19.99 18.4902 20.05 18.6102 20.05C18.6902 20.05 18.7603 20.03 18.8303 19.97C19.1103 19.34 19.2302 18.39 19.2302 16.97V7.05001C19.2302 5.65001 19.1003 4.70001 18.8303 4.07001C18.7503 3.98001 18.6702 3.97001 18.6102 3.97001C18.4902 3.97001 18.0402 4.03001 17.3002 4.82001C16.7602 5.40001 16.0203 5.71001 15.2803 5.67001C14.5303 5.63001 13.8302 5.24001 13.3502 4.61001L12.3403 3.27001C11.8503 2.61001 11.1102 2.61001 10.6202 3.27001L9.60022 4.63001C9.13022 5.26001 8.44026 5.64001 7.70026 5.68001C6.96026 5.72001 6.22024 5.41001 5.68024 4.84001C5.07024 4.18001 4.60027 3.96001 4.34027 3.97001C4.28027 3.97001 4.21025 3.99001 4.13025 4.07001C3.86025 4.70001 3.73022 5.65001 3.73022 7.05001V16.97C3.73022 18.38 3.86025 19.33 4.13025 19.96C4.22025 20.04 4.28027 20.05 4.34027 20.06C4.59027 20.07 5.06023 19.85 5.67023 19.2C6.20023 18.63 6.89026 18.33 7.58026 18.33Z" fill="currentColor" />
                    <path d="M16 11H8C7.59 11 7.25 10.66 7.25 10.25C7.25 9.84 7.59 9.5 8 9.5H16C16.41 9.5 16.75 9.84 16.75 10.25C16.75 10.66 16.41 11 16 11Z" fill="currentColor" />
                    <path d="M14 14.5H8C7.59 14.5 7.25 14.16 7.25 13.75C7.25 13.34 7.59 13 8 13H14C14.41 13 14.75 13.34 14.75 13.75C14.75 14.16 14.41 14.5 14 14.5Z" fill="currentColor" />
                  </svg>
                </div>
              </div>

              {/* PAYMENT STATUS */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Status</span>
                </div>
                <div>
                  <span className="text-xs sm:text-base font-medium">
                    {status === 2 ? (
                      <span className="text-green-500 uppercase">Sukses</span>
                    ) : status === 3 ? (
                      <span className="text-red-700 uppercase">Gagal</span>
                    ) : (
                      <span className="text-yellow-500 uppercase">Dalam Proses</span>
                    )}
                  </span>
                </div>
              </div>

              {/* COUNTER */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Pengisian Ke</span>
                </div>
                <div className="text-left">
                  <span className="text-xs sm:text-base font-medium">{counter ?? 1}</span>
                </div>
              </div>

              {/* BONUSES POINTS */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Bonus Poin</span>
                </div>
                <div className="text-left">
                  <span className="text-xs sm:text-base font-medium">{point} Poin</span>
                </div>
              </div>

              {/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
              {print ? (
                <div>
                  {/* LABEL NAME */}
                  {print.map(({ label, value }, index) => (
                    <Fragment key={index}>
                      <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                        <div>
                          <span className={`${labelTheme} text-xs sm:text-base font-medium`}>{label}</span>
                        </div>
                        <div style={{ maxWidth: "50%" }}>
                          <span className="text-xs sm:text-base font-medium">
                            {value}
                          </span>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                </div>
              ) : (
                /* WHEN THERE IS A SN SHOW THE LABEL */
                <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                  <div>
                    <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Nomor Serial</span>
                  </div>
                  <div>
                    <span className="text-xs sm:text-base font-medium">{sn ?? "N/A"}</span>
                  </div>
                </div>
              )}

              {/* TRX ID */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>ID Transaksi</span>
                </div>
                <div>
                  <span className="text-xs sm:text-base font-medium uppercase">{id}</span>
                </div>
              </div>

              {/* TRX TIME */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Waktu Transaksi</span>
                </div>
                <div className="text-left">
                  <span className="text-xs sm:text-base font-medium">
                    {moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")} WIB
                  </span>
                </div>
              </div>

              {/* STATUS TIME */}
              <div className="flex flex-col px-2 py-1 lg:p-2 text-left">
                <div>
                  <span className={`${labelTheme} text-xs sm:text-base font-medium`}>Waktu Status</span>
                </div>
                <div className="text-left">
                  <span className="text-xs sm:text-base font-medium">
                    {moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")} WIB
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4">
            <a
              className="flex justify-center items-center text-xs sm:text-base font-medium"
              href="/dashboard/customer-service">
              <a
                className="flex justify-center items-center gap-2 text-xs lg:text-sm font-medium font-dmsans"
                href="/dashboard/customer-service">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 22.3199C7.72 22.3199 7.42998 22.2499 7.16998 22.1099C6.59998 21.8099 6.25 21.2099 6.25 20.5699V19.15C3.23 18.84 1.25 16.6199 1.25 13.4399V7.43994C1.25 3.99994 3.56 1.68994 7 1.68994H17C20.44 1.68994 22.75 3.99994 22.75 7.43994V13.4399C22.75 16.8799 20.44 19.1899 17 19.1899H13.23L8.96997 22.03C8.67997 22.22 8.34 22.3199 8 22.3199ZM7 3.17993C4.42 3.17993 2.75 4.84993 2.75 7.42993V13.43C2.75 16.01 4.42 17.68 7 17.68C7.41 17.68 7.75 18.02 7.75 18.43V20.56C7.75 20.69 7.83 20.75 7.88 20.78C7.93 20.81 8.03001 20.84 8.14001 20.77L12.59 17.81C12.71 17.73 12.86 17.68 13.01 17.68H17.01C19.59 17.68 21.26 16.01 21.26 13.43V7.42993C21.26 4.84993 19.59 3.17993 17.01 3.17993H7V3.17993Z" fill="currentColor" />
                  <path d="M11.9998 12.1099C11.5898 12.1099 11.2498 11.7699 11.2498 11.3599V11.1499C11.2498 9.9899 12.0998 9.41989 12.4198 9.19989C12.7898 8.94989 12.9098 8.7799 12.9098 8.5199C12.9098 8.0199 12.4998 7.60986 11.9998 7.60986C11.4998 7.60986 11.0898 8.0199 11.0898 8.5199C11.0898 8.9299 10.7498 9.2699 10.3398 9.2699C9.92984 9.2699 9.58984 8.9299 9.58984 8.5199C9.58984 7.1899 10.6698 6.10986 11.9998 6.10986C13.3298 6.10986 14.4098 7.1899 14.4098 8.5199C14.4098 9.6599 13.5698 10.2299 13.2598 10.4399C12.8698 10.6999 12.7498 10.8699 12.7498 11.1499V11.3599C12.7498 11.7799 12.4098 12.1099 11.9998 12.1099Z" fill="currentColor" />
                  <path d="M12 14.6001C11.58 14.6001 11.25 14.2601 11.25 13.8501C11.25 13.4401 11.59 13.1001 12 13.1001C12.41 13.1001 12.75 13.4401 12.75 13.8501C12.75 14.2601 12.42 14.6001 12 14.6001Z" fill="currentColor" />
                </svg>
                Komplain ke CS
              </a>
            </a>
          </div>
        </Fragment>
      )}
    </Fragment >
  );
};

export default withRouter(TrxListDetailsPage);